import React from 'react';
import FreeOfferings from './FreeOfferings';
import { FilterContextProvider } from '../../../context/FilterContext';

const ChooseFreeCourses = ({ categoryId }: { categoryId: string }) => {
  return (
    <FilterContextProvider>
      <FreeOfferings categoryId={categoryId} />
    </FilterContextProvider>
  );
};

export default ChooseFreeCourses;
